import React from 'react';
import { PictoProps } from './index';

export const SwitchLeft = (props: PictoProps) => (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="24.5"
      y="0.5"
      width="24"
      height="24"
      rx="6.5"
      transform="rotate(90 24.5 0.5)"
      stroke="#000000"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.224 12.9775L14.6747 17.8024C14.992 18.0659 15.4773 18.0659 15.776 17.8024C16.0747 17.5389 16.0747 17.0943 15.776 16.8308L10.8667 12.5L15.776 8.16916C16.0747 7.88922 16.0747 7.46108 15.776 7.1976C15.4773 6.93413 14.992 6.93413 14.6747 7.1976L9.224 12.006C8.92533 12.2859 8.92533 12.7141 9.224 12.9775Z"
      fill="#000000"
    />
  </svg>
);
